/* eslint-disable */
// src/layouts/local/data/localTableData.js

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

export default function localTableData({
  localsDetails,
  onEdit,
  onDelete,
  onDetails,
  darkMode = false,
}) {
  const hasDeleteAction = typeof onDelete === "function";

  const columns = [
    {
      Header: "Local y cliente",
      accessor: "Name",
      align: "left",
      Cell: ({ row, value }) => {
        const destination = onDetails?.(row.original._local);
        const localAndOwner = (
          <>
            {value}
            {"\u00a0\u00a0·\u00a0\u00a0"}
            <MDTypography
              component="span"
              variant="body2"
              fontWeight="regular"
              color="inherit"
              opacity={0.8}
              sx={{ display: "inline", fontSize: "18px", lineHeight: 1.5, overflowWrap: "anywhere" }}
            >
              {row.original.OwnerName}
            </MDTypography>
          </>
        );
        return (
          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              fontSize: "18px",
              lineHeight: 1.5,
              whiteSpace: "normal",
            }}
          >
            {destination ? (
              <Box
                component={Link}
                to={destination.pathname}
                state={destination.state}
                sx={{
                  fontSize: "18px",
                  lineHeight: 1.5,
                  color: darkMode ? "#82BEFF" : "info.main",
                  textDecoration: "underline",
                  textUnderlineOffset: "2px",
                  overflowWrap: "anywhere",
                  "&:hover": { color: darkMode ? "#B7DAFF" : "info.dark" },
                  "&:focus-visible": {
                    outline: "2px solid",
                    outlineColor: darkMode ? "#82BEFF" : "info.main",
                    outlineOffset: 2,
                  },
                }}
              >
                {localAndOwner}
              </Box>
            ) : (
              <Box component="span" sx={{ fontSize: "18px", overflowWrap: "anywhere" }}>
                {localAndOwner}
              </Box>
            )}
          </Box>
        );
      },
    },
    { Header: "Editar local", accessor: "Actions", align: "right" },
  ];

  // helper para armar una fila de local normal
  const buildLocalRow = (local) => ({
    _id: local.Id ?? local.LocalId,
    Name: local.Name,
    Address: local.Address,
    OwnerName: local.Person.Name,
    _local: local,
    Actions: (
      <MDBox>
        <IconButton
          name="updateLocal"
          aria-label="edit"
          color="primary"
          onClick={() => onEdit(local.Id ?? local.LocalId)}
          sx={{ minWidth: 44, minHeight: 44 }}
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
        {hasDeleteAction && (
          <IconButton
            name="deleteLocal"
            aria-label="delete"
            color="secondary"
            onClick={() => onDelete(local.Id ?? local.LocalId)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </MDBox>
    ),
  });

  const rows = (localsDetails || []).map((local) => buildLocalRow(local));

  return {
    columns,
    rows,
  };
}
